import { Overlay } from '@farol-ds/react'
import * as RDialog from '@radix-ui/react-dialog'
import classNames from 'classnames'
import { forwardRef } from 'react'

import { useFullscreenModal } from '../context'
import styles from './styles/content.module.scss'

export type FullscreenModalContentElement = HTMLDivElement
export type FullscreenModalContentProps = RDialog.DialogContentProps & {
  containerClassName?: string
}

const FullscreenModalContent = forwardRef<
  FullscreenModalContentElement,
  FullscreenModalContentProps
>(function FullscreenModalContent(props, forwardedRef) {
  const { className, children, containerClassName, ...rest } = props

  const { isMount, onOpenChange } = useFullscreenModal()

  const classes = classNames(
    styles.root,
    {
      [styles.rootVisible]: isMount,
    },
    className
  )

  const containerClasses = classNames(styles.container, containerClassName)

  function handleOverlayClick() {
    onOpenChange?.(false)
  }

  return (
    <RDialog.Portal>
      <RDialog.Overlay asChild>
        <Overlay visible={isMount} />
      </RDialog.Overlay>

      <RDialog.Content
        aria-describedby={undefined}
        {...rest}
        className={classes}
        ref={forwardedRef}
      >
        <div
          data-aria-hidden="true"
          aria-hidden="true"
          className={styles.overlay}
          onClick={handleOverlayClick}
        />

        <div className={containerClasses}>{children}</div>
      </RDialog.Content>
    </RDialog.Portal>
  )
})

export default FullscreenModalContent
